import initialState from "./model";

export default {
  setCurrentVerificationStep(state, currentVerificationStep) {
    state.currentVerificationStep = currentVerificationStep;
  },
  setCurrentVerificationMethod(state, currentVerificationMethod) {
    state.currentVerificationMethod = currentVerificationMethod;
  },
  setActiveIcon(state, activeIcon) {
    state.activeIcon = activeIcon;
  },
  setAllowedVerificationMethods(state, allowedVerificationMethods) {
    state.allowedVerificationMethods = allowedVerificationMethods;
  },
  setStartedAt(state, startedAt) {
    state.startedAt = startedAt;
  },
  setBackendAuthorizationStatus(state, status) {
    state.backendAuthorizationStatus = status;
  },
  resetState(state) {
    Object.assign(state, initialState());
  },
};
